import { useState } from "react";

// The component accepts a 'tabs' array as a prop
export default function Tabs({ tabs, clearLog }) {
  const [activeTab, setActiveTab] = useState(0);

  // Guard against empty array
  if (!tabs || tabs.length === 0) return null;

  return (
    <div className="w-full border rounded shadow-sm">
      {/* Dynamic Tab Navigation Headers */}
      <div className="flex border-b bg-gray-50 overflow-x-auto">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`px-6 py-3 font-medium whitespace-nowrap transition-colors duration-150 ${activeTab === index
              ? "border-b-2 border-blue-500 text-blue-600 bg-white"
              : "text-gray-500 hover:text-gray-700 hover:bg-gray-100"
              }`}
            onClick={() => setActiveTab(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Dynamic Tab Body */}
      <div className="bg-white p-6" style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', 'overflowY': 'auto' }}>
        <button
          onClick={() => { clearLog(tabs[activeTab].label); }}
          className="mb-3 bg-green-500  text-white px-4 py-2 rounded mt-4 cursor-pointer disabled:opacity-50 }"
        >
          Clear Log
        </button>
        <div>{tabs[activeTab].content}</div>
      </div>
    </div>
  );
}
